import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import { useAlert } from "../../../context/AlertContext";
import { Container, Tabs, Tab } from "react-bootstrap";
import PreviePlanForm from "./Tabs/PreviePlanForm";
import { getServiceRequest, addEditServiceRequest } from "../../../commons/ServiceRequest";
import TechnicianPlansService from "../../../services/technicianplan.service";
import PreviewOther from "./Tabs/PreviewOther";
import PreviewRepair from "./Tabs/PreviewRepair";
import PreviewInstall from "./Tabs/PreviewInstall";

export default function PlanningPreview() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [selectedTab, setSelectedTab] = useState("");
  const Id = state?.Id || [];
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    handleChangeTab("EventplaningDetail");
    setTimeout(() => setWebsiteName("ข้อมูลการวางแผน"), 300);
  }, []);

  const handleChangeTab = (key) => {
    switch (key) {
      case "EventplaningDetail":
        setWebsiteName("ข้อมูลการวางแผน");
        setSelectedTab("EventplaningDetail");
        break;
      case "EventplaningCalendar":
        setWebsiteName("ปฏิทินงานช่าง");
        setSelectedTab("EventplaningCalendar");
        break;
      default:
        setWebsiteName("หัวหน้าวางแผนงาน");
        setSelectedTab("EventPlanning");
    }
  };

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Head Event Planning Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey={"EventplaningDetail"}
          onSelect={(k) => handleChangeTab(k)}
        >
          <Tab eventKey="EventPlanning" title="หัวหน้าวางแผนงาน" disabled>
          </Tab>
          <Tab eventKey="EventplaningDetail" title="ข้อมูลการวางแผน">
            {state.seq_serv_id
              ? <PreviewRepair Id={Id} />
              : state.seq_inst_id ? <PreviewInstall Id={Id} />
                : <PreviewOther Id={Id} />}
          </Tab>
          <Tab eventKey="EventplaningCalendar" title="ปฏิทินงานช่าง" disabled>
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
